import React, { Fragment } from 'react'
import { shape, string, number, arrayOf, func } from 'prop-types'

import classNames from 'src/common/helpers/class-names'
import {
  Title,
  Rating,
  Promo,
} from 'shared/interim/product'

import { BLOCK as blk } from './constants'

const TitleRatingBundlePromo = ({
  promoDetails,
  ratingAndReview,
  name,
  categoryId,
  mods,
  handleProductClick,
  itemUrl,
}) => (
  <Fragment>
    <div className={classNames({ blk, elt: 'title-container', mods })}>
      <Title
        href={itemUrl}
        value={name}
        mods
        clickHandler={handleProductClick}
      />
    </div>

    <div className={classNames({ blk, elt: 'rating-container' })}>
      <Rating clickHandler={handleProductClick} itemUrl={itemUrl} {...ratingAndReview} />
    </div>

    <div className={classNames({ blk, elt: 'promo-container', mods })}>
      <Promo
        {...promoDetails}
        itemName={name}
        categoryId={categoryId}
        mods={mods}
      />
    </div>
  </Fragment>
)

TitleRatingBundlePromo.propTypes = {
  promoDetails: shape({ bundledItemCount: number }).isRequired,
  ratingAndReview: shape({ totalReviewCount: number }).isRequired,
  name: string.isRequired,
  categoryId: string,
  mods: arrayOf(string),
  handleProductClick: func,
  itemUrl: string.isRequired,
}

TitleRatingBundlePromo.defaultProps = {
  categoryId: '',
  mods: [],
  handleProductClick() {},
}

export default TitleRatingBundlePromo



// WEBPACK FOOTER //
// ./shared/interim/product-list/item/title-rating-bundle-promo.js